import { render, staticRenderFns } from "./CustomInputs.vue?vue&type=template&id=f072aea2&"
import script from "./CustomInputs.vue?vue&type=script&lang=js&"
export * from "./CustomInputs.vue?vue&type=script&lang=js&"
import style0 from "./CustomInputs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports